import {StandardThemeCustomizer} from "../../../services/theme/standard-theme-customizer";

export class MrGreenThemeCustomizer extends StandardThemeCustomizer {
    getHomePageTopBannerHeight(): string {
        if (this.services.mediaQuery.mAndBelow) {
            return "21rem";
        }

        return "28rem";
    }
}
